import React from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
const LoadingBackdrop = ({ loading, label }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Backdrop, { sx: (theme) => ({
                color: "#005800",
                zIndex: theme.zIndex.drawer + 1,
                backgroundColor: "rgba(5, 100, 10, 0.1)", // Set the backdrop color to a shade of green
            }), open: loading },
            React.createElement(Typography, { variant: "h4", sx: { marginRight: "20px" } }, label !== null && label !== void 0 ? label : "Loading Trials",
                " "),
            React.createElement(CircularProgress, { sx: { color: "#005600" } }))));
};
export default LoadingBackdrop;
